<script setup lang="ts">
import { useHead } from '@unhead/vue';
import Divider from '@/layout/Divider.vue';
import Layout from '@/layout/Layout.vue';

useHead({
  title: "Albano's Villa | Menu",
  meta: [
    {
      name: 'description',
      content:
        "The Albano's Villa menu: hand-tossed pizza with house-ground sausage, our signature taco pizza, pasta, sandwiches and salads — made fresh daily.",
    },
  ],
});
</script>

<template>
  <Layout sidebar="images-food" main-class="*:not-first:text-center">
    <h1>Menu</h1>
    <h2>PIZZA</h2>
    <ul>
      <li>available in 10 and 14 inch</li>
      <li>
        Freshly made dough, sauce with our special spices, and our special blend of mozzarella
        cheese.
      </li>
    </ul>
    <h3>Toppings</h3>
    <ul>
      <li>Italian sausage (ground in house with our traditional seasonings)</li>
      <li>pepperoni-bacon-ham-anchovy-tomato-pineapple-bell pepper</li>
      <li>black olive-onion-jalapeno-banana pepper-mushroom</li>
    </ul>
    <h3>Specialty Pizzas</h3>
    <ul>
      <li class="underline">Taco pizza</li>
      <li>Our homemade taco meat covered with mozzarella cheese</li>
      <li>fresh sliced tomatoes</li>
      <li>topped with shredded lettuce</li>
    </ul>
    <ul>
      <li class="underline">Veggie pizza</li>
      <li>mushroom-onion-black olive</li>
      <li>bell pepper-tomato</li>
    </ul>
    <ul>
      <li class="underline">Albano's masterpiece</li>
      <li>sausage-pepperoni</li>
      <li>mushroom-onion-black olive</li>
      <li>bell pepper-tomato</li>
    </ul>
    <h2>PASTA CHOICES</h2>
    <ul>
      <li>spaghetti - mostaccioli</li>
      <li>ravioli (meat or cheese)</li>
      <li>thick cut lasagna</li>
      <li>pasta topped with our homemade, slow cooked meat sauce, or marinara sauce</li>
    </ul>
    <p>linguine with clam sauce (made fresh by the Albano family)</p>
    <p>all pasta served with 2 pieces of garlic bread</p>
    <ul>
      <li>additions to pasta</li>
      <li>meatballs</li>
      <li>Italian sausage</li>
      <li>chicken breast</li>
      <li>and don't forget</li>
      <li>"add cheese"</li>
    </ul>
    <h2>SANDWICHES</h2>
    <ul>
      <li>available in 6 or 12 inch</li>
      <li>Italian beef - Italian sausage</li>
      <li>meatball sub</li>
      <li>(bell peppers and pepperoncini included)</li>
      <li>Stromboli: pizza sauce, mozzarella cheese, choice of any pizza toppings</li>
      <li>
        Hot submarine: pizza sauce, onions, banana peppers, pepperoni, salami, ham, bologna baked
        with pizza cheese
      </li>
    </ul>
    <ul>
      <li>
        Cold Italian grinder: provolone cheese, spiced capacola ham, pepperoni, salami, and Italian
        beef
      </li>
      <li>topped with lettuce, tomato, onion, and pepperoncini</li>
      <li>served with our homemade Italian dressing</li>
    </ul>
    <p>Villa burger</p>
    <h2>SALADS</h2>
    <ul>
      <li>Antipasto salad: Italian meats and cheese served with our Italian dressing</li>
      <li>Chicken Caesar salad</li>
      <li>Taco salad</li>
      <li>Side salad with choice of dressing</li>
    </ul>
    <h2>WE ALSO HAVE</h2>
    <ul>
      <li>Our homemade ground beef tacos</li>
      <li>Wet burritos</li>
      <li>Hot wings</li>
      <li>Italian wings</li>
      <li>Garlic bread</li>
      <li>Garlic Cheese bread</li>
    </ul>
    <p class="mt-40">
      <strong>BEER AND WINE AVAILABLE</strong>
    </p>
    <Divider />
  </Layout>
</template>
